<template>
	<div class="page">
		<div class="container-fluid">
			<div style="display: flex;align-items: flex-end;">
				<span style="font-size: 20px;color:#fff">{{formatType(type).title}}</span>
			</div>
			<span style="margin-top: 10px;font-size: 14px;color:#fff">{{formatType(type).value}}</span>
			
		</div>
		<ChargeCenter></ChargeCenter>
		<!-- <FileList ref="list" v-if="type==='list'" @toEdit="toEdit"></FileList> -->
	</div>
</template>

<script>
	import ChargeCenter from '../../components/charge/ChargeCenter.vue'
	let types = {
		list: {
			title: '充值中心',
			value: 'charge center'
		}
	}
	export default {
		components: {
			ChargeCenter,
		},
		data() {
			return {
				type: 'list',
				id: null
			}
		},
		filters: {
			formatType(value) {
				return types[value]
			}
		},

		methods: {
			formatType(value) {
				return types[value]
			},
		}
	}
</script>

<style>
	.page {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
	}

	.page .container-fluid {
		padding: 45px 25px;
		display: flex;
		flex-direction: column;
		background-color: rgb(66, 75, 79);
		position: relative;
		color: #e6e6e6;
	}

	.page .container-fluid .inner-btn {
		width: 120px;
		height: 40px;
		border: 1px solid #ccc;
		position: absolute;
		top: 40px;
		right: 20px;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		cursor: pointer;
	}
	.page .container-fluid .inner-btn:hover{
		background-color: #9a9a9a;
	}
</style>